import CustomerLogin from "../../pages/auth/customer";
import ForgotPassword from "../../pages/auth/forgot-password";
import Login from "../../pages/auth/Login";
import ManagementLogin from "../../pages/auth/management";
import NotFound from "../../pages/auth/NotFound";
import ResetPassword from "../../pages/auth/reset-password";
import TranportAgentLogin from "../../pages/auth/transport-agent";
import TranporterLogin from "../../pages/auth/transporter";
import LogisticHome from "../../pages/qdp/logistics";
import AboutUs from "../../pages/qdp/logistics/aboutUs";
import { GoogleAuthRegisterPage } from "../../pages/qdp/customer/google-register/register";
import { GoogleAuthRegisteredPage } from "../../pages/qdp/customer/google-register/registered";
import CustomerHome from "../../pages/qdp/customer/home";
import { RegisterCustomer } from "../../pages/registrations/customerRegistry";
import { RegisterTransportAgent } from "../../pages/registrations/transportAgentRegistry";
import { RegisterTransporter } from "../../pages/registrations/transporterRegistry";
import { RoleGuard } from "../guards";
import Faq from "../../components/customer/faq";
import Contact from "../../pages/qdp/customer/contact";
import OrderBooking from "../../pages/qdp/customer/order-booking/order-booking";
import IndexOrderDetails from "../../pages/qdp/customer/order-booking/order-detail";
import Cargo from "../../pages/qdp/cargo";
import CargoOrderBooking from "../../pages/qdp/cargo/order";
import CargoOrderDetails from "../../pages/qdp/cargo/order-details";
import TrackOrder from "../../pages/qdp/customer/order/track-order";
import { OrderTracking } from "../../pages/qdp/customer/order/track-order/order-tracking";
import LoginOTP from "../../pages/auth/login-with-OTP";
import LogisticHomeMobile from "../../pages/qdp/mobile-view/customer/logistics";
import OrderBookingMobile from "../../pages/qdp/mobile-view/customer/order-booking/order-booking";
import IndexOrderDetailMobile from "../../pages/qdp/mobile-view/customer/order-booking/order-detail";
import CargoMobile from "../../pages/qdp/mobile-view/cargo";
import CargoOrderBookingMobile from "../../pages/qdp/mobile-view/cargo/order";
import CargoOrderDetailsMobile from "../../pages/qdp/mobile-view/cargo/order-details";
import { Terms } from "../../components/customer/terms";
import TrainerLogin from "../../pages/auth/trainer";
import { TrainerRegistration } from "../../pages/trainer/register";
import MentorLogin from "../../pages/auth/mentor";
import { MentorRegistration } from "../../pages/mentor/register";
import AgencyLogin from "../../pages/auth/agencies";
import { AgencyRegistration } from "../../pages/agencies/register";
import VentureLogin from "../../pages/auth/ventures";
import { VentureRegistration } from "../../pages/ventures/register";
import Programs from "../../components/programs";
import Communities from "../../components/communities";
import Events from "../../components/events";
import OneUserLogin from "../../pages/auth/oneuser";
import { OneUserRegistration } from "../../pages/oneuser/register";
import Ventureview from "../../components/ventures-view";
import Agencyview from "../../components/agencies-view";
import CandidateLogin from "../../pages/auth/candidate";
import { CandidateRegistration } from "../../pages/candidate/register";
import MobilePrograms from "../../pages/qdp/mobile-view/customer/logistics/mobile-programs";
import MobileEvents from "../../pages/qdp/mobile-view/customer/logistics/mobile-events/mobile-events";
import MobileCommunities from "../../pages/qdp/mobile-view/customer/logistics/mobile-communities/mobile-community";
import Parnerview from "../../components/partner-view";
import PartnerLogin from "../../pages/auth/partner";
import { PartnerRegistration } from "../../pages/partner/register";
import Membership from "../../components/membership";
import MentorsPage from "../../components/mentors";
import DigiitPage from "../../components/digiit";
import RaiseFrameWorkPage from "../../components/raise-frame";
import TestimonialPage from "../../components/testimonial";
import DbnNetwork from "../../components/dbn-network";
import Communitiesmoredetails from "../../components/communities/communities-moredetails.component";
import ProgramsMoreDetails from "../../components/programs/program-more-details.component";
import EventsMoreDetails from "../../components/events/event-more-detail.component";
import OneDigiitHomePage from "../../pages/one-x";
import Eda from "../../pages/one-x/eda";
import PartnerNetworkPage from "../../pages/one-x/partner";
import CatalystPage from "../../pages/one-x/ecosystem";
import DIGIITSite from "../../pages/one-x/digiit";
import EventsHubPage from "../../pages/one-x/events";
import CommunitiesPageV2 from "../../pages/one-x-v2/community/communities";
import { CommunitySubscription } from "../../pages/one-x-v2/community/community-subscription-form";
import CommunityHub from "../../pages/one-x-v2/communityhub/communityhub";
import { TalkwithusForm } from "../../pages/one-x-v2/community/community-talkwithus-form";
import { EventsBooking } from "../../pages/one-x-v2/community/eventsbooking-form";





export const onexV2AppRoutes = ({ width }: any) => {
	return (
		(width && width > 724 ?
			[
				{ index: true, element: <RoleGuard roles={["customer"]}><OneDigiitHomePage /></RoleGuard> },  
				{ path: "academy", element: <RoleGuard roles={["customer"]}><Eda /></RoleGuard> },
				{ path: "communities", element: <RoleGuard roles={["customer"]}><CommunitiesPageV2 /></RoleGuard> },
				{ path: "partners", element: <RoleGuard roles={["customer"]}><PartnerNetworkPage /></RoleGuard> },
				{ path: "ecosystem", element: <RoleGuard roles={["customer"]}><CatalystPage /></RoleGuard> },
				{ path: "digiit", element: <RoleGuard roles={["customer"]}><DIGIITSite /></RoleGuard> },
				{ path: "events", element: <RoleGuard roles={["customer"]}><EventsHubPage /></RoleGuard> },

				{ path: "customer/support", element: <RoleGuard roles={["customer"]}><Faq /></RoleGuard> },
				{ path: "venture-view", element: <RoleGuard roles={["customer"]}><Ventureview /></RoleGuard> },
				{ path: "partner-view", element: <RoleGuard roles={["customer"]}><Parnerview /></RoleGuard> },
				{ path: "agencies-view", element: <RoleGuard roles={["customer"]}><Agencyview /></RoleGuard> },
				// { path: "events", element: <RoleGuard roles={["customer"]}><Events /></RoleGuard> },
				{ path: "register/transporter", element: <RoleGuard roles={["customer"]}><RegisterTransporter /></RoleGuard> },
				{ path: "register/customer", element: <RoleGuard roles={["customer"]}><RegisterCustomer /></RoleGuard> },
				{ path: "register/transport-agent", element: <RoleGuard roles={["customer"]}><RegisterTransportAgent /></RoleGuard> },
				{ path: "register", element: <RoleGuard roles={["customer"]}><GoogleAuthRegisterPage /></RoleGuard> },
				{ path: "registered", element: <RoleGuard roles={["customer"]}><GoogleAuthRegisteredPage /></RoleGuard> },
				{ path: "about-us", element: <RoleGuard roles={["customer"]}><AboutUs /></RoleGuard> },
				{ path: "auth/login", element: <RoleGuard roles={["customer"]}>< LoginOTP /></RoleGuard> },
				// { path: "catalyst", element: <RoleGuard roles={["Internal"]}><MentorsPage /></RoleGuard> },
				{ path: "digiit", element: <RoleGuard roles={["Internal"]}><DigiitPage /></RoleGuard> },
				{ path: "raise-frame", element: <RoleGuard roles={["Internal"]}><RaiseFrameWorkPage /></RoleGuard> },
				{ path: "testimonial", element: <RoleGuard roles={["Internal"]}><TestimonialPage /></RoleGuard> },
				{ path: "dbn-network", element: <RoleGuard roles={["Internal"]}><DbnNetwork /></RoleGuard> },

				{ path: "auth/login/management", element: <RoleGuard roles={["customer"]}><ManagementLogin /></RoleGuard> },
				{ path: "auth/login/customer", element: <RoleGuard roles={["customer"]}><CustomerLogin /></RoleGuard> },
				{ path: "auth/login/forgot-password", element: <RoleGuard roles={["customer"]}><ForgotPassword /></RoleGuard> },
				{ path: "auth/login/reset-password", element: <RoleGuard roles={["customer"]}><ResetPassword /></RoleGuard> },
				{ path: "notfound", element: <RoleGuard roles={["customer"]}>< NotFound /></RoleGuard> },
				//Trainer
				{ path: 'trainer/login', element: <RoleGuard roles={["customer"]}><TrainerLogin /></RoleGuard> },
				{ path: 'trainer/register', element: <RoleGuard roles={["customer"]}><TrainerRegistration /></RoleGuard> },
				//Trainer
				//Oneuser
				{ path: 'oneuser/login', element: <RoleGuard roles={["customer"]}><OneUserLogin /></RoleGuard> },
				{ path: 'oneuser/register', element: <RoleGuard roles={["customer"]}><OneUserRegistration /></RoleGuard> },
				//Oneuser
				{ path: "membership", element: <RoleGuard roles={["customer"]}><Membership /></RoleGuard> },
				{ path: "communities/:id", element: <RoleGuard roles={["customer"]}><Communitiesmoredetails /></RoleGuard> },
				{ path: "programs/:id", element: <RoleGuard roles={["customer"]}><ProgramsMoreDetails /></RoleGuard> },
				{ path: "events-details/:id", element: <RoleGuard roles={["customer"]}><EventsMoreDetails /></RoleGuard> },

				//Mentor 
				{ path: 'mentor/login', element: <RoleGuard roles={["customer"]}><MentorLogin /></RoleGuard> },
				{ path: 'mentor/register', element: <RoleGuard roles={["customer"]}><MentorRegistration /></RoleGuard> },
				//Mentor

				//Agencies
				{ path: 'agencies/login', element: <RoleGuard roles={["customer"]}><AgencyLogin /></RoleGuard> },
				{ path: 'agencies/register', element: <RoleGuard roles={["customer"]}><AgencyRegistration /></RoleGuard> },
				//Agencies

				//Venture
				{ path: 'venture/login', element: <RoleGuard roles={["customer"]}><VentureLogin /></RoleGuard> },
				{ path: 'venture/register', element: <RoleGuard roles={["customer"]}><VentureRegistration /></RoleGuard> },
				//Venture

				//candidate
				{ path: 'candidate/login', element: <RoleGuard roles={["customer"]}><CandidateLogin /></RoleGuard> },
				{ path: 'candidate/register', element: <RoleGuard roles={["customer"]}><CandidateRegistration /></RoleGuard> },
				//candidate

				//Partner
				{ path: 'partner/login', element: <RoleGuard roles={["customer"]}><PartnerLogin /></RoleGuard> },
				{ path: 'partner/register', element: <RoleGuard roles={["customer"]}><PartnerRegistration /></RoleGuard> },
				//Partner
				{ path: 'communities/subscription-form', element: <RoleGuard roles={["customer"]}><CommunitySubscription /></RoleGuard> },
				{ path: 'communities/community-hub', element: <RoleGuard roles={["customer"]}><CommunityHub /></RoleGuard> },
				{ path: 'communities/talkwithus-form', element: <RoleGuard roles={["customer"]}><TalkwithusForm /></RoleGuard> },
				{ path: 'communities/eventsbooking-form', element: <RoleGuard roles={["customer"]}><EventsBooking /></RoleGuard> },

			]
			: [
				{ index: true, element: <RoleGuard roles={["customer"]}><OneDigiitHomePage /></RoleGuard> },  
				{ path: "academy", element: <RoleGuard roles={["customer"]}><Eda /></RoleGuard> },
				{ path: "communities", element: <RoleGuard roles={["customer"]}><CommunitiesPageV2 /></RoleGuard> },
				{ path: "partners", element: <RoleGuard roles={["customer"]}><PartnerNetworkPage /></RoleGuard> },
				{ path: "ecosystem", element: <RoleGuard roles={["customer"]}><CatalystPage /></RoleGuard> },
				{ path: "digiit", element: <RoleGuard roles={["customer"]}><DIGIITSite /></RoleGuard> },
				{ path: "events", element: <RoleGuard roles={["customer"]}><EventsHubPage /></RoleGuard> },

				{ path: "home", element: <RoleGuard roles={["customer"]}><CustomerHome /></RoleGuard> },
				{ path: "customer/support", element: <RoleGuard roles={["customer"]}><Faq /></RoleGuard> },
				{ path: "register/transporter", element: <RoleGuard roles={["customer"]}><RegisterTransporter /></RoleGuard> },
				{ path: "register/customer", element: <RoleGuard roles={["customer"]}><RegisterCustomer /></RoleGuard> },
				{ path: "register/transport-agent", element: <RoleGuard roles={["customer"]}><RegisterTransportAgent /></RoleGuard> },
				{ path: "register", element: <RoleGuard roles={["customer"]}><GoogleAuthRegisterPage /></RoleGuard> },
				{ path: "registered", element: <RoleGuard roles={["customer"]}><GoogleAuthRegisteredPage /></RoleGuard> },
				{ path: "about-us", element: <RoleGuard roles={["customer"]}><AboutUs /></RoleGuard> },
				{ path: "auth/login", element: <RoleGuard roles={["customer"]}>< LoginOTP /></RoleGuard> },
				{ path: "auth/login/transporter", element: <RoleGuard roles={["customer"]}><TranporterLogin /></RoleGuard> },
				{ path: "auth/login/transport-agent", element: <RoleGuard roles={["customer"]}><TranportAgentLogin /></RoleGuard> },
				{ path: "auth/login/management", element: <RoleGuard roles={["customer"]}><ManagementLogin /></RoleGuard> },
				{ path: "auth/login/customer", element: <RoleGuard roles={["customer"]}><CustomerLogin /></RoleGuard> },
				{ path: "auth/login/forgot-password", element: <RoleGuard roles={["customer"]}><ForgotPassword /></RoleGuard> },
				{ path: "auth/login/reset-password", element: <RoleGuard roles={["customer"]}><ResetPassword /></RoleGuard> },
				{ path: "notfound", element: <RoleGuard roles={["customer"]}>< NotFound /></RoleGuard> },
				{ path: "customer/contact", element: <RoleGuard roles={["customer"]}><Contact /></RoleGuard> },
				{ path: "order-booking", element: <RoleGuard roles={["customer"]}>< OrderBookingMobile /></RoleGuard> },
				{ path: "customer/order-detail", element: <RoleGuard roles={["customer"]}>< IndexOrderDetailMobile /></RoleGuard> },
				{ path: "customer/order/track", element: <RoleGuard roles={["customer"]}><TrackOrder /></RoleGuard> },
				{ path: "customer/order/order-tracking", element: <RoleGuard roles={["customer"]}><OrderTracking /></RoleGuard> },
				{ path: "cargo", element: <RoleGuard roles={["customer"]}>< CargoMobile /></RoleGuard> },
				{ path: "cargo/booking", element: <RoleGuard roles={["customer"]}>< CargoOrderBookingMobile /></RoleGuard> },
				{ path: "cargo/order-details", element: <RoleGuard roles={["customer"]}>< CargoOrderDetailsMobile /></RoleGuard> },
				{ path: "terms/:id", element: <RoleGuard roles={["customer"]}>< Terms /></RoleGuard> },
				{ path: "/", element: <RoleGuard roles={["customer"]}><LogisticHome /></RoleGuard> },
				{ path: "home", element: <RoleGuard roles={["customer"]}><CustomerHome /></RoleGuard> },
				{ path: "customer/support", element: <RoleGuard roles={["customer"]}><Faq /></RoleGuard> },
				{ path: "programs", element: <RoleGuard roles={["customer"]}><Programs /></RoleGuard> },
				{ path: "communities", element: <RoleGuard roles={["customer"]}><Communities /></RoleGuard> },
				{ path: "events", element: <RoleGuard roles={["customer"]}><Events /></RoleGuard> },
				{ path: "register/transporter", element: <RoleGuard roles={["customer"]}><RegisterTransporter /></RoleGuard> },
				{ path: "register/customer", element: <RoleGuard roles={["customer"]}><RegisterCustomer /></RoleGuard> },
				{ path: "register/transport-agent", element: <RoleGuard roles={["customer"]}><RegisterTransportAgent /></RoleGuard> },
				{ path: "register", element: <RoleGuard roles={["customer"]}><GoogleAuthRegisterPage /></RoleGuard> },
				{ path: "registered", element: <RoleGuard roles={["customer"]}><GoogleAuthRegisteredPage /></RoleGuard> },
				{ path: "about-us", element: <RoleGuard roles={["customer"]}><AboutUs /></RoleGuard> },
				{ path: "auth/login", element: <RoleGuard roles={["customer"]}>< LoginOTP /></RoleGuard> },

				{ path: "auth/login/management", element: <RoleGuard roles={["customer"]}><ManagementLogin /></RoleGuard> },
				{ path: "auth/login/customer", element: <RoleGuard roles={["customer"]}><CustomerLogin /></RoleGuard> },
				{ path: "auth/login/forgot-password", element: <RoleGuard roles={["customer"]}><ForgotPassword /></RoleGuard> },
				{ path: "auth/login/reset-password", element: <RoleGuard roles={["customer"]}><ResetPassword /></RoleGuard> },
				{ path: "notfound", element: <RoleGuard roles={["customer"]}>< NotFound /></RoleGuard> },
				//Trainer
				{ path: 'trainer/login', element: <RoleGuard roles={["customer"]}><TrainerLogin /></RoleGuard> },
				{ path: 'trainer/register', element: <RoleGuard roles={["customer"]}><TrainerRegistration /></RoleGuard> },
				//Trainer
				//Oneuser
				{ path: 'oneuser/login', element: <RoleGuard roles={["customer"]}><OneUserLogin /></RoleGuard> },
				{ path: 'oneuser/register', element: <RoleGuard roles={["customer"]}><OneUserRegistration /></RoleGuard> },
				//Oneuser


				//Mentor
				{ path: 'mentor/login', element: <RoleGuard roles={["customer"]}><MentorLogin /></RoleGuard> },
				{ path: 'mentor/register', element: <RoleGuard roles={["customer"]}><MentorRegistration /></RoleGuard> },
				//Mentor

				//Agencies
				{ path: 'agencies/login', element: <RoleGuard roles={["customer"]}><AgencyLogin /></RoleGuard> },
				{ path: 'agencies/register', element: <RoleGuard roles={["customer"]}><AgencyRegistration /></RoleGuard> },
				//Agencies

				//Venture
				{ path: 'venture/login', element: <RoleGuard roles={["customer"]}><VentureLogin /></RoleGuard> },
				{ path: 'venture/register', element: <RoleGuard roles={["customer"]}><VentureRegistration /></RoleGuard> },
				//Venture

				{ path: 'communities/subscription-form', element: <RoleGuard roles={["customer"]}><CommunitySubscription /></RoleGuard> },
				{ path: 'communities/community-hub', element: <RoleGuard roles={["customer"]}><CommunityHub /></RoleGuard> },
				{ path: 'communities/talkwithus-form', element: <RoleGuard roles={["customer"]}><TalkwithusForm /></RoleGuard> },
				{ path: 'communities/eventsbooking-form', element: <RoleGuard roles={["customer"]}><EventsBooking /></RoleGuard> },
				

			]))
			
};
